import styled from "styled-components";

export const ButtonWrapper = styled.button`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: 0.1em;
  background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
  color: ${({ theme }) => theme.colors.primaria};
  border: 1px solid ${({ theme }) => theme.colors.primaria};
  border-radius: 4px;
  cursor: pointer;

  @media only screen and (max-width: 500px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &.primaryButton {
    background-color: ${({ theme }) => theme.colors.primaria};
    color: ${({ theme }) => theme.colors.background};
  }

  &.secondaryButton {
    background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
    color: ${({ theme }) => theme.colors.fontePadrao};
    border: 1px solid ${({ theme }) => theme.colors.fonteLight};
    padding: 8px 12px;
    letter-spacing: 0;
    font-size: 13px;
  }

  &.textButton {
    color: ${({ theme }) => theme.colors.fontePadrao};
    padding: 8px 12px;
    border: none;
    background: none;
    letter-spacing: 0;
    text-decoration: underline;
    font-size: 13px;
  }

  &.buttonDisabled {
    color: ${({ theme }) => theme.colors.fonteLight};
    background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
    border-color: ${({ theme }) => theme.colors.fonteLight};

    &.primaryButton {
      background-color: ${({ theme }) => theme.colors.secundaria};
    }
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  transition-duration: 0.4s;

  &:hover {
    filter: brightness(1.15);
  }
`;
